import { render } from "./CirclesList.vue?vue&type=template&id=4baf4312"
import script from "./CirclesList.vue?vue&type=script&lang=js"
export * from "./CirclesList.vue?vue&type=script&lang=js"

import "./CirclesList.vue?vue&type=style&index=0&id=4baf4312&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__